import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { OrderDetailsData, OrderDetailsService }  from './OrderDetails.service';

import { ProductsData, ProductsService } from '../Products/Products.service';
import { OrdersData, OrdersService } from '../Orders/Orders.service';

@Component({
  template: require('./OrderDetailsDetails.component.html'),
  providers: [OrderDetailsService
	, ProductsService, OrdersService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrderDetailsDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objOrderDetails: OrderDetailsData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	ProductsList: ProductsData[];
	OrdersList: OrdersData[];

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private OrderDetailsService: OrderDetailsService
			, private  ProductsService:  ProductsService
			, private  OrdersService:  OrdersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objOrderDetails = new OrderDetailsData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.OrderDetailsService.getByID(+params['id']))
		.switchMap((params: Params) => this.OrderDetailsService.getByID(params['id']))
		.subscribe((item: OrderDetailsData) => this.objOrderDetails = item);
		this.getLookups();
	}

	deleteOrderDetails(id: number) {
		if (window.confirm('Are you sure you want to delete this OrderDetails?') == true)
		{
			this.OrderDetailsService.deleteOrderDetails(this.objOrderDetails.OrderID.toString())
			.subscribe(record => this.router.navigate(['/OrderDetails']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('OrderDetails record deleted successfully...'); }
			);
		}
	}
	gotoOrderDetailsEdit() {
		this.router.navigate(['/OrderDetails', this.objOrderDetails.OrderID]);
	}

	gotoOrderDetails() {
		this.router.navigate(['/OrderDetails']);
	}

	// Get Lookup List for Products
    getProducts() {
		this.ProductsService.getAll().subscribe(records => this.ProductsList=records);
    }
	// Get Lookup List for Orders
    getOrders() {
		this.OrdersService.getAll().subscribe(records => this.OrdersList=records);
    }

	getLookups() {

        this.getProducts();
        this.getOrders();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetails/OrderDetailsDetails.component.ts